import Vue from "vue";
import Vuex from "vuex";

import storeVuex from "./modules/config";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    storeVuex,
  },
});
